import React, { useState, useEffect } from 'react';
import { X, FileText, Receipt, ClipboardList, DollarSign, Send } from 'lucide-react';
import { API_URL } from '../servicios/api';

const ModalEnviarDocumentos = ({ isOpen, onClose, aviso, onUpdateAviso }) => {
  const [documentos, setDocumentos] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [mensajeExito, setMensajeExito] = useState(null);

  useEffect(() => {
    if (aviso && aviso.documentos_a_enviar) {
      try {
        const documentosParseados = JSON.parse(aviso.documentos_a_enviar);
        setDocumentos(documentosParseados);
      } catch (e) {
        console.error("Error al parsear documentos_a_enviar:", e);
        setDocumentos([]);
      }
    } else {
      setDocumentos([]);
    }
    setError(null);
    setMensajeExito(null);
  }, [aviso]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError(null);
    setMensajeExito(null);

    const token = localStorage.getItem('token');
    if (!token) {
      setError('No autenticado. Por favor, inicia sesión.');
      setCargando(false);
      return;
    }

    const formData = new FormData();
    formData.append('id_aviso', aviso.id_aviso);
    formData.append('estado', 'completado');

    try {
      const respuesta = await fetch(`${API_URL}/actualizar_aviso.php`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      const datos = await respuesta.json();

      if (datos.exito) {
        setMensajeExito('¡Documentos marcados como enviados y aviso completado!');
        onUpdateAviso({ ...aviso, estado: 'completado' });
        setTimeout(onClose, 1500);
      } else {
        setError(datos.mensaje);
      }
    } catch (err) {
      console.error('Error al actualizar aviso:', err);
      setError('Error de conexión con el servidor.');
    } finally {
      setCargando(false);
    }
  };

  const getIconoDocumento = (documento) => {
    switch (documento) {
      case 'factura':
        return <FileText className="w-5 h-5 mr-2 text-blue-400" />;
      case 'albaran':
        return <Receipt className="w-5 h-5 mr-2 text-green-400" />;
      case 'informe_tecnico':
        return <ClipboardList className="w-5 h-5 mr-2 text-yellow-400" />;
      case 'presupuesto':
        return <DollarSign className="w-5 h-5 mr-2 text-purple-400" />;
      default:
        return null;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-slate-800 p-6 rounded-lg shadow-xl w-full max-w-md border border-slate-700 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-slate-400 hover:text-white transition-colors"
        >
          <X className="w-6 h-6" />
        </button>
        <h2 className="text-2xl font-bold text-white mb-2">Enviar Documentos</h2>
        <p className="text-slate-400 mb-4">Aviso #{aviso?.numero_aviso ?? aviso?.id_aviso} - {aviso?.nombre_cliente}</p>

        <div className="space-y-3 mb-6">
          <h3 className="text-slate-300 font-semibold">Documentos requeridos:</h3>
          {documentos.length > 0 ? (
            <ul className="space-y-2">
              {documentos.map(doc => (
                <li key={doc} className="flex items-center bg-slate-700 p-2 rounded-md">
                  {getIconoDocumento(doc)}
                  <span className="text-slate-200 capitalize">{doc.replace('_', ' ')}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-slate-400">No hay documentos especificados para este aviso.</p>
          )}
        </div>

        {error && <p className="text-red-400 text-sm mb-4">{error}</p>}
        {mensajeExito && <p className="text-green-400 text-sm mb-4">{mensajeExito}</p>}

        <button
          type="button"
          onClick={handleSubmit}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          disabled={cargando || documentos.length === 0}
        >
          {cargando ? (
            'Procesando...'
          ) : (
            <>
              <Send className="w-5 h-5 mr-2" />
              Marcar como Completado
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ModalEnviarDocumentos;